import { Component, Input } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';

@Component({
  selector: 'app-form-udienza-preliminare-view',
  templateUrl: './form-udienza-preliminare-view.component.html',
  styleUrls: ['./form-udienza-preliminare-view.component.css']
})
export class FormUdienzaPreliminareViewComponent {
  labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;

  @Input() ctxBodyFascicolo;
  constructor() {}
}
